import { useCallback } from 'react';
import { useRouter, useRouterState } from '@tanstack/react-router';
import type { QueryParamAdapterComponent } from 'use-query-params';

/**
 * A use-query-params adapter that integrates with TanStack Router.
 * Uses the router's history object for push/replace operations
 * so that TanStack Router stays in sync with URL changes.
 */
export const TanStackRouterAdapter: QueryParamAdapterComponent = ({ children }) => {
  const router = useRouter();
  const searchStr = useRouterState({ select: (s) => s.location.searchStr });

  const push = useCallback(
    (newLocation: { search: string }) => {
      const currentPath = window.location.pathname;
      router.history.push(currentPath + newLocation.search);
    },
    [router],
  );

  const replace = useCallback(
    (newLocation: { search: string }) => {
      const currentPath = window.location.pathname;
      router.history.replace(currentPath + newLocation.search);
    },
    [router],
  );

  return children({
    push,
    replace,
    location: { search: searchStr ?? '' },
  });
};
